module.exports = "/images/ElSalvador.png?9d31ef913a99447a2e9138f0615c7687";